import gql from 'graphql-tag';

export default gql`
    query CountLoadsByJobSummaryIdsAndStatus($input: CountLoadsInput) {
        countLoadsByJobSummaryIdsAndStatus(input: $input) {
            count
        }
    }
`;
